module.exports = __webpack_public_path__ + "static/media/QRCodeFrame.07b75656.svg";